import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { ProvidersServices } from "../../../../../providers/services";
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ProductPartialWfoodcostProviderSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-partial-wfoodcost-provider-selected',
    templateUrl: 'product-partial-wfoodcost-provider-selected.html',
})
export class ProductPartialWfoodcostProviderSelectedPage {

    //datatable
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public providersServices: ProvidersServices,
        public translate: TranslateService,) {

    }

    ionViewWillEnter() {
    }

    setDefault(name) {
        for (let provider of this.providersServices.providers_array_tmp) {
            if (provider[1] == name) {
                provider[10] = true;
            } else {
                provider[10] = false;
            }
        }
        this.providersServices.providers_array_tmp = [...this.providersServices.providers_array_tmp];
    }

    delete(element) {
        var index = this.providersServices.providers_array_tmp.findIndex(x => x[0] == element[0]);
        if (index >= 0) {
            this.providersServices.providers_array_tmp.splice(index, 1);
            this.providersServices.providers_array_tmp = [...this.providersServices.providers_array_tmp];
        }
    }

    clickElement(event) {
        this.delete(event);
    }
}


// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-select-provider/product-partial-wfoodcost-provider-selected/product-partial-wfoodcost-provider-selected.ts